/* eslint-disable */
import { curry, sign as sign_1 } from "../common/.fable/fable-library.3.2.9//Util.js";
import { op_Subtraction } from  "../common/.fable/fable-library.3.2.9/Date.js";
import { days as days_1 } from  "../common/.fable/fable-library.3.2.9/TimeSpan.js";
import { printf, toText } from  "../common/.fable/fable-library.3.2.9/String.js";
import { value as value_2 } from  "../common/.fable/fable-library.3.2.9/Option.js";
import { toList, map2, head, map, length, mapIndexed, sumBy } from  "../common/.fable/fable-library.3.2.9/Seq.js";
import { head as head_1, tail, isEmpty } from  "../common/.fable/fable-library.3.2.9/List.js";

/*
This file and ncasui/src/fable folder are auto generated by fable. They are the F# Irr calculation in NCAS.Calculations.Irr.fs 
translated to javascript, by fable. 

To Create this file and .fable folder:
NOTE: 1-3 are done, the project is found in NCAS/src/ncasFableApp

https://fable.io/docs/2-steps/your-first-fable-project.html
or:
Start a new project
Now we're ready, let's start a new project using Fable!

Use a Fable template
The easiest way to get started with Fable is to use a template (learn more about dotnet templates). For a minimal Fable project, create and navigate to a new directory and run the following commands (first one is only needed if you haven't installed the template yet in your system).

1. dotnet new --install Fable.Template
2. dotnet new fable

Install dependencies
3. JS dependencies are listed in the package.json file. You can yarn install, which will download the needed packages to the node_modules folder and create a lock file.
(.NET dependencies are listed in the src/App.fsproj file. You can install them by running dotnet restore src, but this is already automatically done by Fable.)
(Lock files (like package-lock.json if you're using npm) should be committed to ensure reproducible builds whenever anybody clones your repo. For .NET dependencies you can create a lock file by using Paket.)

Build & run the app
4. Here we go. If you've already installed JS dependencies, just run npm start. After a few seconds, your web server app will be running in the background until you kill it.

You can access your project at http://localhost:8080/ with your favorite browser.
5. Copy the NCAS.Calculations.Irr file to the Library.fs file at NCAS/src/ncasFableApp/src/Library.fs
6. Need to switch the node version to something greater than or equal to version 12 to run.
    6a. Run nvm list to see installed versions, if dont have correct version download it from https://nodejs.org/en/download/
    6b. Switch node version to correct versionusin command (example): nvm use v17.8.0
7. The server is in “watch” mode. Each time you save an .fs F# source file, Fable rebuilds the project automatically. If the build succeeds, you will see your changes in the browser without refreshing the page; if not, nothing changes in the browser, and you can see the build errors in the server’s console output.
The npm start command is just an alias for dotnet fable watch src --run webpack-dev-server, check the "scripts" section of the package.json file. Please also check the README.md file shipped with the template to get up-to-date instructions.
8. Switch node version back so NCAS can run -  v10.18.0
9. Copy the new NCAS/src/ncasFableApp/src/Library.fs.js javascript file contents to the Irr.js file in the /src of the clientapp.
10. Copy the NCAS/src/ncasFableApp/src/.fable folder and rename to replace the ncasui/src/fable folder in the ncasui/clientapp/src folder

*/
export function throw$(s) {
    throw (new Error(s));
}

export function elseThrow(s, c) {
    if (!c) {
        throw$(s);
    }
}

export function sign(x) {
    return sign_1(x);
}

export function idem(x) {
    return x;
}

export function days(after, before) {
    let copyOfStruct = op_Subtraction(after, before);
    return days_1(copyOfStruct) | 0;
}

export function findBounds(f, guess, minBound, maxBound, precision) {
    if ((guess <= minBound) ? true : (guess >= maxBound)) {
        throw$(toText(printf("guess needs to be between %f and %f"))(minBound)(maxBound));
    }
    const shift = 0.1;
    const factor = 1.6;
    const maxTries = 100;
    const adjValueToMin = (value) => {
        if (value <= minBound) {
            return minBound + precision;
        }
        else {
            return value;
        }
    };
    const adjValueToMax = (value_1) => {
        if (value_1 >= maxBound) {
            return maxBound - precision;
        }
        else {
            return value_1;
        }
    };
    const rfindBounds = (low_mut, up_mut, tries_mut) => {
        let y, x, y_2, x_2, y_4, x_4;
        rfindBounds:
        while (true) {
            const low = low_mut, up = up_mut, tries = tries_mut;
            const tries_1 = (tries - 1) | 0;
            if (tries_1 === 0) {
                throw$(toText(printf("Not found an interval comprising the root after %i tries, last tried was (%f, %f)"))(maxTries)(low)(up));
            }
            const lower = adjValueToMin(low);
            const upper = adjValueToMax(up);
            const matchValue = [f(lower), f(upper)];
            if ((y = matchValue[1], (x = matchValue[0], (x * y) === 0))) {
                return [lower, upper];
            }
            else if ((y_2 = matchValue[1], (x_2 = matchValue[0], (x_2 * y_2) < 0))) {
                return [lower, upper];
            }
            else if ((y_4 = matchValue[1], (x_4 = matchValue[0], (x_4 * y_4) > 0))) {
                low_mut = (lower + (factor * (lower - upper)));
                up_mut = (upper + (factor * (upper - lower)));
                tries_mut = tries_1;
                continue rfindBounds;
            }
            else {
                return throw$(toText(printf("FindBounds: one of the values (%f, %f) cannot be used to evaluate the objective function"))(lower)(upper));
            }
            break;
        }
    };
    const low_1 = adjValueToMin(guess - shift);
    const high = adjValueToMax(guess + shift);
    return rfindBounds(low_1, high, maxTries);
}

export const bisection = (() => {
    const maxCount = 200;
    const helper = (f_mut, a_mut, b_mut, count_mut, precision_mut) => {
        helper:
        while (true) {
            const f = f_mut, a = a_mut, b = b_mut, count = count_mut, precision = precision_mut;
            if (a === b) {
                throw$(toText(printf("(a=b=%f) impossible to start bisection"))(a));
            }
            const fa = f(a);
            if (Math.abs(fa) < precision) {
                return a;
            }
            else {
                const fb = f(b);
                if (Math.abs(fb) < precision) {
                    return b;
                }
                else {
                    const newCount = (count + 1) | 0;
                    if (newCount > maxCount) {
                        throw$(toText(printf("No root found in %i iterations"))(maxCount));
                    }
                    if ((fa * fb) > 0) {
                        throw$(toText(printf("(%f,%f) don\u0027t bracket the root"))(a)(b));
                    }
                    const midvalue = a + (0.5 * (b - a));
                    const fmid = f(midvalue);
                    if (Math.abs(fmid) < precision) {
                        return midvalue;
                    }
                    else if ((fa * fmid) < 0) {
                        f_mut = f;
                        a_mut = a;
                        b_mut = midvalue;
                        count_mut = newCount;
                        precision_mut = precision;
                        continue helper;
                    }
                    else if ((fa * fmid) > 0) {
                        f_mut = f;
                        a_mut = midvalue;
                        b_mut = b;
                        count_mut = newCount;
                        precision_mut = precision;
                        continue helper;
                    }
                    else {
                        return throw$("Bisection: It should never get here");
                    }
                }
            }
            break;
        }
    };
    return curry(5, helper);
})();

export const newton = (() => {
    const maxCount = 20;
    const helper = (f_mut, x_mut, count_mut, precision_mut) => {
        helper:
        while (true) {
            const f = f_mut, x = x_mut, count = count_mut, precision = precision_mut;
            const d = (f_1, x_1) => ((f_1(x_1 + precision) - f_1(x_1 - precision)) / (2 * precision));
            const fx = f(x);
            const Fx = d(f, x);
            const newX = x - (fx / Fx);
            if (Math.abs(newX - x) < precision) {
                return newX;
            }
            else if (count > maxCount) {
                return void 0;
            }
            else {
                f_mut = f;
                x_mut = newX;
                count_mut = (count + 1);
                precision_mut = precision;
                continue helper;
            }
            break;
        }
    };
    return curry(4, helper);
})();

export function findRoot(f, guess) {
    const precision = 1E-06;
    const newtValue = newton(f)(guess)(0)(precision);
    if ((newtValue != null) ? (sign(guess) === sign(value_2(newtValue))) : false) {
        return value_2(newtValue);
    }
    else {
        const patternInput = findBounds(f, guess, -1, 1.7976931348623157E+308, precision);
        const upper = patternInput[1];
        const lower = patternInput[0];
        return bisection(f)(lower)(upper)(0)(precision);
    }
}

export function fvFactor(r, nper) {
    return Math.pow(1 + r, nper);
}

export function pvFactor(r, nper) {
    return 1 / fvFactor(r, nper);
}

export function npv(r, cfs) {
    return sumBy((x) => idem(x), mapIndexed((i, cf) => (cf * pvFactor(r, i + 1)), cfs), {
        GetZero: () => 0,
        Add: (x_1, y) => (x_1 + y),
    });
}

export function irr(cfs, guess) {
    return findRoot((r) => npv(r, cfs), guess);
}

export function mirr(cfs, financeRate, reinvestRate) {
    const n = length(cfs);
    const positives = map((cf) => {
        if (cf > 0) {
            return cf;
        }
        else {
            return 0;
        }
    }, cfs);
    const negatives = map((cf_1) => {
        if (cf_1 < 0) {
            return cf_1;
        }
        else {
            return 0;
        }
    }, cfs);
    return Math.pow(((-npv(reinvestRate, positives)) * Math.pow(1 + reinvestRate, n)) / (npv(financeRate, negatives) * (1 + financeRate)), 1 / (n - 1)) - 1;
}

export function xnpv(r, cfs, dates) {
    const d0 = head(dates);
    return sumBy((x) => idem(x), map2((d, cf) => (cf / Math.pow(1 + r, days(d, d0) / 365)), dates, cfs), {
        GetZero: () => 0,
        Add: (x_1, y) => (x_1 + y),
    });
}

export function xirr(cfs, dates, guess) {
    return findRoot((r) => xnpv(r, cfs, dates), guess);
}

export function validCfs(cfs) {
    const _validCfs = (cfs_1_mut, pos_mut, neg_mut) => {
        let t_2, h_2, t, h;
        _validCfs:
        while (true) {
            const cfs_1 = cfs_1_mut, pos = pos_mut, neg = neg_mut;
            if (pos ? neg : false) {
                return true;
            }
            else {
                let pattern_matching_result, h_1, t_1;
                if (!isEmpty(cfs_1)) {
                    if ((t = tail(cfs_1), (h = head_1(cfs_1), h > 0))) {
                        pattern_matching_result = 0;
                        h_1 = head_1(cfs_1);
                        t_1 = tail(cfs_1);
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        cfs_1_mut = t_1;
                        pos_mut = true;
                        neg_mut = neg;
                        continue _validCfs;
                    }
                    case 1: {
                        let pattern_matching_result_1, h_3, t_3;
                        if (!isEmpty(cfs_1)) {
                            if ((t_2 = tail(cfs_1), (h_2 = head_1(cfs_1), h_2 <= 0))) {
                                pattern_matching_result_1 = 0;
                                h_3 = head_1(cfs_1);
                                t_3 = tail(cfs_1);
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                        switch (pattern_matching_result_1) {
                            case 0: {
                                cfs_1_mut = t_3;
                                pos_mut = pos;
                                neg_mut = true;
                                continue _validCfs;
                            }
                            case 1: {
                                if (isEmpty(cfs_1)) {
                                    return false;
                                }
                                else {
                                    throw (new Error("Should never get here"));
                                }
                            }
                        }
                    }
                }
            }
            break;
        }
    };
    return _validCfs(toList(cfs), false, false);
}

export function ncasIRR(cfs) {
    elseThrow("There must be one positive and one negative cash flow", validCfs(cfs));
    return irr(cfs, 0.1);
}

